(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bufflow-cinematic-intro"] && !Shopify.designMode) return;
  try {
    
(function(){
  var LOGO_D = [
  "M1809 4521 c-92 -46 -209 -148 -269 -236 -82 -120 -120 -235 -120 -365 0 -150 44 -251 162 -376 l68 -72 -32 -19 c-18 -11 -61 -45 -96 -76 -64 -58 -115 -89 -164 -101 -38 -9 -35 -22 14 -67 48 -44 132 -91 196 -110 23 -7 42 -14 42 -16 0 -11 -126 -202 -208 -316 -156 -217 -193 -319 -193 -528 0 -66 3 -125 7 -131 4 -6 16 13 27 43 36 98 122 211 104 137 -3 -13 -9 -64 -13 -113 -14 -191 36 -329 164 -455 93 -91 176 -141 300 -180 51 -17 97 -30 102 -30 5 0 -18 28 -53 63 -59 59 -107 138 -123 202 -7 28 -3 26 62 -32 111 -98 222 -166 489 -298 137 -68 283 -145 323 -172 260 -173 393 -380 379 -593 -2 -41 -8 -83 -12 -94 -12 -27 1 -20 104 52 193 136 347 309 427 477 54 114 73 186 80 300 8 119 -6 181 -75 330 -7 15 69 -43 122 -94 51 -49 55 -45 33 34 -22 83 -61 169 -111 247 -44 67 -136 183 -160 200 -14 10 -7 13 69 25 92 15 152 53 185 116 21 43 25 67 32 195 4 91 17 200 34 286 34 173 31 203 -34 316 -62 106 -66 123 -51 210 7 39 9 74 6 77 -7 7 -77 -54 -93 -81 -19 -33 -15 -78 12 -132 14 -27 25 -50 25 -51 0 -1 -26 -7 -57 -13 -32 -7 -110 -25 -173 -40 -213 -51 -357 -48 -510 11 -97 37 -153 79 -179 132 -27 55 -27 99 0 154 26 54 72 92 169 140 l75 38 130 -1 c122 0 140 -3 280 -43 169 -47 310 -65 320 -39 9 23 -42 174 -91 268 -105 206 -285 351 -534 434 -138 45 -257 60 -418 53 -231 -11 -388 -69 -594 -219 -66 -48 -67 -49 -96 -34 -38 20 -80 70 -105 126 -46 101 -17 298 60 413 19 28 36 54 39 59 9 14 -40 8 -77 -11z m-119 -271 c-32 -167 20 -307 143 -390 80 -54 177 -81 312 -89 l110 -6 23 -45 c15 -31 22 -62 22 -103 0 -63 -14 -99 -54 -136 -24 -23 -30 -24 -108 -18 -223 17 -448 133 -537 276 -68 111 -79 234 -33 367 26 74 70 150 108 189 23 23 25 15 14 -45z m666 -465 c64 -64 84 -196 44 -280 -17 -36 -87 -101 -97 -91 -2 2 8 24 23 49 45 81 42 201 -7 299 -11 21 -19 40 -19 43 0 14 34 2 56 -20z m-216 -1035 c191 -173 364 -271 740 -420 112 -45 117 -51 29 -34 -232 44 -440 122 -578 217 -153 105 -336 313 -366 417 -5 16 11 0 42 -40 28 -36 87 -99 133 -140z",
  "M2908 3360 c-92 -48 -92 -48 62 -71 128 -18 137 -24 53 -39 -40 -6 -73 -15 -73 -19 0 -13 95 -79 133 -91 48 -15 91 -7 132 24 25 20 39 23 76 19 38 -4 50 -1 77 22 59 50 63 84 10 85 -10 0 -79 23 -153 50 -168 62 -228 66 -317 20z"
  ];

  var storm  = document.getElementById('bfw-storm');

  var cv     = document.getElementById('bfw-grain');
  if(!storm || !cv || storm.dataset.ready) return;
  storm.dataset.ready = '1';

  
  var SETTLE = 1750;   
  var CRISP  = 3150;   
  var EXIT   = 5200;   

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var seen = false;
  try { seen = sessionStorage.getItem('bfw_storm') === '1'; } catch(e){}
  if((seen && new URLSearchParams(location.search).get('bufflow_intro') !== '1') || reduce || window.Shopify?.designMode){
    storm.classList.add('bfw-gone');
    return;
  }

  /* HD: ekranin gercek piksel yogunluguna kadar ciz (retina/telefonlarda 3x) */
  var W = innerWidth, H = innerHeight, dpr = Math.min(devicePixelRatio || 1, 3);
  cv.width = Math.round(W*dpr); cv.height = Math.round(H*dpr); cv.style.width = W+'px'; cv.style.height = H+'px';
  var g = cv.getContext('2d', {alpha:true}); g.scale(dpr, dpr);
  g.imageSmoothingEnabled = true; g.imageSmoothingQuality = 'high';

  var size = Math.min(H*0.44, W*0.62, 400);
  var ox = W/2 - size/2, oy = H*0.44 - size/2;
  var PATH = (function(){
    var p = new Path2D();
    var m = new DOMMatrix().translateSelf(ox, oy).scaleSelf(size/512, size/512)
                           .translateSelf(0, 512).scaleSelf(0.1, -0.1);
    for(var i=0;i<LOGO_D.length;i++){ p.addPath(new Path2D(LOGO_D[i]), m); }
    return p;
  })();

  /* HD: logoyu daha sik noktalarla ornekle */
  var targets = [];
  (function(){
    var off = document.createElement('canvas');
    off.width = Math.ceil(W); off.height = Math.ceil(H);
    var o = off.getContext('2d');
    o.fillStyle = '#fff'; o.fill(PATH);
    var d = o.getImageData(0,0,off.width,off.height).data;
    var step = size > 300 ? 2 : 1.5;
    for(var y=0;y<off.height;y+=step){
      for(var x=0;x<off.width;x+=step){
        var ix = (Math.floor(y)*off.width + Math.floor(x))*4 + 3;
        if(d[ix] > 140){ targets.push(x,y); }
      }
    }
  })();

  var N = Math.min(Math.floor(targets.length/2), 6000), P = [];
  for(var i=0;i<N;i++){
    var ti = (Math.random()*(targets.length/2))|0;
    P.push({
      x: Math.random()*W*1.6 - W*0.3, y: Math.random()*H,
      v: 3 + Math.random()*11, len: 4 + Math.random()*22,
      a: .18 + Math.random()*.6,
      c: Math.random() < 0.2 ? '242,169,59' : '244,231,211',
      tx: targets[ti*2] + (Math.random()-.5)*1.2,
      ty: targets[ti*2+1] + (Math.random()-.5)*1.2,
      d: Math.random()*420, dur: 620 + Math.random()*560,
      sx:0, sy:0, locked:false
    });
  }

  var t0 = performance.now(), raf = null, last = null;
  var DOT = 1.15;
  function ease(t){ return 1 - Math.pow(1-t, 3); }

  function frame(now){
    var t = now - t0;
    /* HD: hareket kare hizindan bagimsiz (60/90/120 Hz ekranlarda ayni hiz, akici) */
    var dt = last == null ? 1 : Math.min(3, (now - last) / 16.667);
    last = now;
    g.clearRect(0,0,W,H);
    var dens  = t < 300 ? t/300 : (t < SETTLE ? 1 : Math.max(0, 1 - (t-SETTLE)/700));
    var speed = t < SETTLE ? (0.35 + 0.65*Math.min(1, t/1400)) : 1;

    for(var i=0;i<P.length;i++){
      var p = P[i];
      if(t < SETTLE){
        p.x += p.v*speed*dt; p.y -= p.v*speed*0.05*dt;
        if(p.x > W+30){ p.x = -30 - Math.random()*W*0.3; p.y = Math.random()*H; }
        if(i/P.length > dens) continue;
        g.strokeStyle = 'rgba('+p.c+','+(p.a*0.55)+')'; g.lineWidth = 0.9;
        g.beginPath(); g.moveTo(p.x,p.y); g.lineTo(p.x - p.len*speed, p.y + p.len*0.05); g.stroke();
      } else {
        if(!p.locked){
          if(p.sx === 0 && p.sy === 0){ p.sx = p.x; p.sy = p.y; }
          var k = (t - SETTLE - p.d)/p.dur;
          if(k <= 0){
            p.x += p.v*0.8*dt; p.y -= p.v*0.04*dt;
            if(p.x > W+30){ p.x = -30; p.y = Math.random()*H; }
            p.sx = p.x; p.sy = p.y;
            g.fillStyle = 'rgba('+p.c+','+(p.a*0.35)+')';
            g.fillRect(p.x, p.y, DOT, DOT);
            continue;
          }
          if(k >= 1){ p.locked = true; p.x = p.tx; p.y = p.ty; }
          else {
            var e = ease(k);
            p.x = p.sx + (p.tx - p.sx)*e;
            p.y = p.sy + (p.ty - p.sy)*e + Math.sin(k*Math.PI)*(1-e)*18;
          }
        }
        g.fillStyle = 'rgba('+p.c+','+(p.locked ? .92 : .5)+')';
        g.fillRect(p.x, p.y, DOT, DOT);
      }
    }

    if(t > CRISP){
      g.save();
      g.globalAlpha = Math.min(1, (t - CRISP)/900);
      g.fillStyle = '#F4E7D3';
      g.fill(PATH);
      g.restore();
    }
    raf = requestAnimationFrame(frame);
  }

  
  function score(){
    var t = ac.currentTime + 0.02, settle = t + SETTLE/1000;
    function nz(d,k){var n=Math.floor(ac.sampleRate*d),b=ac.createBuffer(1,n,ac.sampleRate),c=b.getChannelData(0);
      for(var i=0;i<n;i++)c[i]=(Math.random()*2-1)*Math.pow(1-i/n,k);return b;}

    var w = ac.createBufferSource(); w.buffer = nz(4.6, 0.25);
    var bp = ac.createBiquadFilter(); bp.type='bandpass'; bp.Q.value=0.6;
    bp.frequency.setValueAtTime(420, t);
    bp.frequency.exponentialRampToValueAtTime(1700, settle-0.25);
    bp.frequency.exponentialRampToValueAtTime(240, settle+1.6);
    var wg = ac.createGain();
    wg.gain.setValueAtTime(0.0001, t);
    wg.gain.exponentialRampToValueAtTime(0.26, settle-0.3);
    wg.gain.exponentialRampToValueAtTime(0.05, settle+1.4);
    wg.gain.exponentialRampToValueAtTime(0.0001, settle+3.0);
    w.connect(bp); bp.connect(wg); wg.connect(ac.destination);
    w.start(t); w.stop(t+4.6);

    var sub = ac.createOscillator(), sg = ac.createGain();
    sub.type='sine';
    sub.frequency.setValueAtTime(58, settle-0.5);
    sub.frequency.exponentialRampToValueAtTime(30, settle+0.6);
    sg.gain.setValueAtTime(0.0001, settle-0.5);
    sg.gain.exponentialRampToValueAtTime(0.4, settle-0.1);
    sg.gain.exponentialRampToValueAtTime(0.0001, settle+1.2);
    sub.connect(sg); sg.connect(ac.destination);
    sub.start(settle-0.5); sub.stop(settle+1.3);

    [523.25, 784.0].forEach(function(f,i){
      var o = ac.createOscillator(), gg = ac.createGain();
      o.type='sine'; o.frequency.value = f;
      gg.gain.setValueAtTime(0.0001, t + CRISP/1000);
      gg.gain.exponentialRampToValueAtTime(i?0.026:0.04, t + CRISP/1000 + 0.3);
      gg.gain.exponentialRampToValueAtTime(0.0001, t + CRISP/1000 + 2.2);
      o.connect(gg); gg.connect(ac.destination);
      o.start(t + CRISP/1000); o.stop(t + CRISP/1000 + 2.3);
    });

  }

  var done = false, started = false, ac = null, timer = null, safety = null;
  var previousFocus = document.activeElement;
  function stopAudio(){ if(ac && ac.state !== 'closed') ac.close().catch(function(){}); }
  function close(){
    cancelAnimationFrame(raf); clearTimeout(timer); clearTimeout(safety); stopAudio();
    storm.close(); document.body.classList.remove('bfw-locked');
    document.removeEventListener('visibilitychange', onVisibility);
    if(previousFocus && previousFocus.isConnected) previousFocus.focus({preventScroll:true});
  }
  function finish(immediate){
    if(done) return; done = true; stopAudio();
    try { sessionStorage.setItem('bfw_storm','1'); } catch(e){}
    if(immediate) close();
    else {storm.style.opacity = '0'; setTimeout(close,420);}
  }
  function play(){
    if(done) return;
    clearTimeout(safety);

    storm.classList.add('bfw-playing');
    document.getElementById('bfw-skip').focus({preventScroll:true});
    t0 = performance.now(); last = null;

    raf = requestAnimationFrame(frame);
    timer = setTimeout(function(){finish(false);},EXIT);
  }
  function start(){
    if(started || done) return; started = true;
    play();
    try {
      var C = window.AudioContext || window.webkitAudioContext;
      if(!C) return;
      ac = new C();
      var audioLimit = setTimeout(stopAudio, 200);
      ac.resume().then(function(){
        clearTimeout(audioLimit);
        if(done || ac.state !== 'running' || performance.now() - t0 > 200){stopAudio();return;}
        try {score();} catch(e){stopAudio();}
      }).catch(function(){clearTimeout(audioLimit);stopAudio();});
    } catch(e){stopAudio();}
  }
  function onVisibility(){if(document.hidden) finish(true);}
  document.getElementById('bfw-skip').onclick = function(){finish(true);};
  storm.addEventListener('cancel',function(e){e.preventDefault();finish(true);});
  document.addEventListener('visibilitychange',onVisibility);
  try {storm.showModal();document.body.classList.add('bfw-locked');start();} catch(e){close();}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
